class PebblFinder extends HTMLElement {
  connectedCallback() {
    this.questions = Array.from(this.querySelectorAll('[data-finder-question]'));
    this.progressLabel = this.querySelector('[data-finder-progress-label]');
    this.progressFill = this.querySelector('[data-finder-progress-fill]');
    this.quizPanel = this.querySelector('.pebbl-finder__quiz');
    this.resultPanel = this.querySelector('[data-finder-result]');
    this.primarySlot = this.querySelector('[data-finder-primary]');
    this.alternatesList = this.querySelector('[data-finder-alternates-list]');
    this.pool = this.querySelector('[data-finder-products]');
    this.restartButton = this.querySelector('[data-finder-restart]');

    this.current = 0;
    this.scores = {};

    this.questions.forEach((question) => {
      question.querySelectorAll('[data-finder-answer]').forEach((button) => {
        button.addEventListener('click', () => this.answer(button));
      });
    });

    if (this.restartButton) {
      this.restartButton.addEventListener('click', () => this.restart());
    }

    this.updateProgress();
  }

  answer(button) {
    const matches = (button.dataset.matches || '')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    matches.forEach((handle) => {
      this.scores[handle] = (this.scores[handle] || 0) + 1;
    });

    this.questions[this.current].hidden = true;
    this.current += 1;

    if (this.current < this.questions.length) {
      this.questions[this.current].hidden = false;
      this.updateProgress();
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      this.showResult();
    }
  }

  updateProgress() {
    const total = this.questions.length;
    const step = Math.min(this.current + 1, total);
    if (this.progressLabel) {
      // Vorlage kommt übersetzt aus der Sprachdatei, siehe pebbl-finder.liquid.
      const template = this.dataset.progressTemplate || '__STEP__ / __TOTAL__';
      this.progressLabel.textContent = template.replace('__STEP__', step).replace('__TOTAL__', total);
    }
    if (this.progressFill) {
      this.progressFill.style.width = `${(step / total) * 100}%`;
    }
  }

  showResult() {
    const cards = Array.from(this.pool.querySelectorAll('[data-finder-product]'));
    const byHandle = {};
    cards.forEach((card) => {
      byHandle[card.dataset.handle] = card;
    });

    const rankedHandles = Object.entries(this.scores)
      .sort((a, b) => b[1] - a[1])
      .map(([handle]) => handle)
      .filter((handle) => byHandle[handle]);

    if (rankedHandles.length === 0 && cards.length > 0) {
      rankedHandles.push(cards[0].dataset.handle);
    }

    const primaryHandle = rankedHandles[0];
    const alternateHandles = rankedHandles.slice(1, 3);

    this.alternatesList.innerHTML = '';

    if (primaryHandle) {
      this.primarySlot.appendChild(byHandle[primaryHandle]);
    }
    alternateHandles.forEach((handle) => {
      this.alternatesList.appendChild(byHandle[handle]);
    });

    this.quizPanel.hidden = true;
    this.resultPanel.hidden = false;
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  restart() {
    Array.from(this.primarySlot.children).forEach((card) => this.pool.appendChild(card));
    Array.from(this.alternatesList.children).forEach((card) => this.pool.appendChild(card));

    this.scores = {};
    this.current = 0;
    this.questions.forEach((question, index) => {
      question.hidden = index !== 0;
    });
    this.updateProgress();

    this.resultPanel.hidden = true;
    this.quizPanel.hidden = false;
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

customElements.define('pebbl-finder', PebblFinder);
